import React, { useEffect, useState } from 'react';
import { observer } from 'mobx-react';
import { useConnectStore } from '../../../../../../store/models';
import LoadingAnimation from '../../../../../../components/LoadingAnimation';
import { useStyles } from './styles';

const ALBATO_URL_TEMPLATE = 'https://connect.ecal.com/user/auth/token?session_token={token}&r=%2Fsolutions%2Fmarketplace%2F{marketplaceID}%3Fview_id%3D1%26config_id%3D145';

function buildAlbatoIframeUrl (token, marketplaceID) {
    const url = ALBATO_URL_TEMPLATE
        .replace('{token}', encodeURIComponent(token))
        .replace('{marketplaceID}', encodeURIComponent(marketplaceID));
    console.log('albato iframe link: -> ', url);
    return url;
}

function AlbatoIframeView () {
    const classes = useStyles();
    const connectStore = useConnectStore();
    const [iframeLoaded, setIframeLoaded] = useState(false);

    useEffect(() => {
        connectStore.getConnectToken();
        // eslint-disable-next-line
    }, []);

    const tokenLoading = connectStore.observed.connectTokenLoading;
    const tokenResolved = !!connectStore.observed.connectToken;
    const tokenFailed = tokenLoading === false && !tokenResolved;

    function renderTokenFailed () {
        return (
            <div className={classes.loadingContainer}>
                <p className={classes.loadingText}>Unable to load integrations. Please try again later.</p>
            </div>
        );
    }

    function renderTokenLoading () {
        return (
            <div className={classes.loadingContainer}>
                <LoadingAnimation />
                <p className={classes.loadingText}>Integrations loading.....</p>
            </div>
        );
    }

    function renderConnectIframe () {
        return (
            <div className={classes.iframeWrapper}>
                {!iframeLoaded && (
                    <div className={classes.iframeOverlay}>
                        <LoadingAnimation />
                        <p className={classes.loadingText}>Integrations loading.....</p>
                    </div>
                )}
                <iframe
                    src={buildAlbatoIframeUrl(connectStore.connectToken, connectStore.marketplaceID)}
                    title="Connect integrations"
                    className={classes.iframe}
                    onLoad={() => setIframeLoaded(true)}
                />
            </div>
        );
    }

    if (tokenFailed) {
        return renderTokenFailed();
    }

    if (tokenLoading || !tokenResolved) {
        return renderTokenLoading();
    }

    return renderConnectIframe();
}

const ObservedAlbatoIframeView = observer(AlbatoIframeView);
export default ObservedAlbatoIframeView;
